import {useFrame} from "@react-three/fiber";
import {useRef} from "react";
import {useDetailViewTransform} from "../DetailViewTransformContext";

/**
 * Renders children in a separate scene pass.
 * Pan is applied inside the scene so gl.render(scene, camera) picks it up.
 * Zoom stays on the shared camera.
 */
const Layer = ({layer, children}) => {
    const sceneRef = useRef(null);
    const {x, y} = useDetailViewTransform();

    useFrame(({gl, camera}) => {
        gl.autoClear = false;
        gl.clearDepth();
        gl.render(sceneRef.current, camera);
    }, layer);

    return (
        <scene ref={sceneRef}>
            <group position={[x, y, 0]}>
                {children}
            </group>
        </scene>
    );
};

export default Layer;
